/**
 * AnnouncementTagService
 * Service for managing announcement-tag mappings
 */
import { CrudService } from '../base/CrudService';
/**
 * Service for announcement tag mapping CRUD operations
 */
export class AnnouncementTagService extends CrudService {
    constructor(http, config) {
        super(http, {
            servicePath: config?.servicePath ?? AnnouncementTagService.DEFAULT_SERVICE_PATH,
            basePath: AnnouncementTagService.BASE_PATH,
            endpoints: config?.endpoints,
        });
    }
    /**
     * Get all tag mappings for a specific announcement
     * GET /api/announcement-tags/by-announcement/{announcementId}
     * @param announcementId - Announcement ID
     * @returns Array of announcement tag mappings
     */
    async getByAnnouncementId(announcementId) {
        const response = await this.getByAnnouncementIdRaw(announcementId);
        return response.data ?? [];
    }
    /**
     * Get all tag mappings for a specific announcement (raw response)
     * @param announcementId - Announcement ID
     */
    getByAnnouncementIdRaw(announcementId) {
        const url = this.buildUrl(`by-announcement/${announcementId}`);
        return this.http.get(url);
    }
    /**
     * Delete a specific tag mapping for an announcement
     * DELETE /api/announcement-tags/{announcementId}/{tagId}
     * @param announcementId - Announcement ID
     * @param tagId - Tag ID
     * @returns True if deleted successfully
     */
    async deleteMapping(announcementId, tagId) {
        const response = await this.deleteMappingRaw(announcementId, tagId);
        return response.success;
    }
    /**
     * Delete a specific tag mapping for an announcement (raw response)
     * @param announcementId - Announcement ID
     * @param tagId - Tag ID
     */
    deleteMappingRaw(announcementId, tagId) {
        const url = this.buildUrl(`${announcementId}/${tagId}`);
        return this.http.delete(url);
    }
}
AnnouncementTagService.DEFAULT_SERVICE_PATH = 'announcements';
AnnouncementTagService.BASE_PATH = 'api/announcement-tags';
//# sourceMappingURL=AnnouncementTagService.js.map